const translations = {
  en: {
    // Navbar
    nav: { riders: 'Riders', drivers: 'Drivers', about: 'About', help: 'Help', signIn: 'Sign in', register: 'Register', signOut: 'Sign out', profile: 'Profile' },
    notifications: {
      title: 'Notifications', markAllRead: 'Mark all read', empty: 'No notifications yet',
      types: {
        NEW_RIDE: 'New ride request available',
        RIDE_ACCEPTED: 'Driver is on the way!',
        RIDE_ARRIVED: 'Driver has arrived',
        RIDE_STARTED: 'Your ride has started',
        RIDE_COMPLETED: 'Ride completed',
        RIDE_CANCELLED: 'Ride was cancelled',
      },
    },
    validation: { required: 'This field is required.', email: 'Please enter a valid email address.' },
    // Footer
    footer: {
      copy: '© 2026 HayTaxi. All rights reserved.',
      tagline: 'Fast, safe and reliable rides — whenever you need them.',
      company: 'Company', about: 'About', help: 'Help',
      ridersCol: 'Riders', bookRide: 'Book a ride', howItWorks: 'How it works',
      driversCol: 'Drivers', becomeDriver: 'Become a driver',
    },
    // Landing
    landing: {
      badge: 'Fast · Safe · Reliable',
      h1a: 'The taxi app', h1b: 'that gets you', h1c: 'there.',
      subtitle: 'Book a ride in seconds, track your driver in real time, and arrive safe — every time.',
      bookBtn: 'Book a ride', driveBtn: 'Become a driver',
      stat1: 'Rides completed', stat2: 'Active drivers', stat3: 'Average rating',
      featuresTitle: 'Why choose HayTaxi?',
      featuresSubtitle: 'Everything you need for a smooth, stress-free ride.',
      features: [
        { title: 'Fast pickup',    desc: 'Your driver arrives in minutes. Real-time matching with nearby drivers.' },
        { title: 'Safe & reliable', desc: 'All rides are tracked. Transparent pricing with no hidden fees.' },
        { title: 'Easy payment',   desc: 'Pay by card or cash. Price calculated upfront before you confirm.' },
      ],
      howBadge: 'How it works',
      howTitle: 'Booking a ride\ntakes 30 seconds.',
      steps: [
        { title: 'Enter your destination', desc: 'Type where you want to go and see the price instantly.' },
        { title: 'Confirm your ride',       desc: 'A nearby driver accepts your request in seconds.' },
        { title: 'Enjoy the journey',       desc: 'Track your driver live and arrive safely.' },
      ],
      bookNow: "Book now — it's free",
      priceLabel: 'Live price estimate', distLabel: 'Distance', durLabel: 'Duration', priceTag: 'Price',
      confirmBook: 'Confirm & book',
      driverTitle: 'Drive with us.\nEarn on your schedule.',
      driverDesc: 'Join hundreds of drivers already earning with HayTaxi. Set your own hours, accept rides when you want, and get paid weekly.',
      startDriving: 'Start driving', learnMore: 'Learn more',
      driverPerks: [
        ['💰', 'Weekly payouts', 'Direct to your bank'],
        ['📱', 'Simple app',     'Accept with one tap'],
        ['🗓️', 'Flexible hours',  'Work when you want'],
        ['⭐', 'Top rated',      'Earn bonuses'],
      ],
    },
    // Auth
    auth: {
      back: '← Back',
      loginTitle: 'Welcome back',
      registerTitle: 'Create account',
      loginSubtitle: 'Sign in to continue',
      joinAsRider: 'Join as a rider',
      joinAsDriver: 'Join as a driver',
      namePlaceholder: 'Full name',
      usernamePlaceholder: 'Email / username',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Password',
      roleRider: 'Rider',
      roleDriver: 'Driver',
      forgotPassword: 'Forgot password?',
      loading: 'Please wait…',
      signIn: 'Sign in',
      createAccount: 'Create account',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      signUp: 'Sign up',
      passwordMinLength: 'Password must be at least 6 characters.',
      genericError: 'Something went wrong. Please try again.',
      checkEmailTitle: 'Check your email',
      checkEmailBefore: "We've sent a confirmation link to ",
      checkEmailAfter: '. Open it to activate your account, then sign in.',
      backToSignIn: 'Back to sign in',
      resendLink: "Didn't get the email? Resend confirmation",
      resendSent: 'Confirmation email sent again.',
      resendError: 'Could not resend the email. Please try again later.',
    },
    verifyEmail: {
      title: 'Confirm your email',
      verifying: 'Confirming your email…',
      successMsg: 'Your email has been confirmed. You can now sign in.',
      errorMsg: 'This confirmation link is invalid or has expired.',
      backToSignIn: 'Back to sign in',
    },
    forgotModal: {
      title: 'Forgot password?',
      subtitle: "Enter your email and we'll send you a password reset link.",
      emailPlaceholder: 'your@email.com',
      cancel: 'Cancel',
      send: 'Send link',
      sending: 'Sending…',
      successBefore: 'We sent a password reset link to ',
      successAfter: '. Open it to set a new password. The link is valid for 1 hour.',
      gotIt: 'Got it',
      genericError: 'Something went wrong. Please try again.',
    },
    resetPassword: {
      title: 'Set a new password',
      subtitle: 'Enter a new password for your account.',
      newPassword: 'New password',
      confirmPassword: 'Repeat new password',
      submitBtn: 'Set new password',
      updating: 'Updating…',
      successMsg: 'Your password has been changed. You can now sign in with it.',
      backToSignIn: 'Back to sign in',
      errFill: 'Please fill in all fields.',
      errMatch: 'Passwords do not match.',
      errLength: 'Password must be at least 6 characters.',
      errGeneral: 'Something went wrong. Please try again.',
    },
    // Booking page
    booking: {
      subtitle: 'Fill in the details and confirm your ride.',
      signInToBook: 'Sign in to book',
      loginHint: "You'll be asked to sign in before confirming",
      calculating: 'Calculating…',
      distanceError: 'Could not calculate distance. Enter manually.',
    },
    // Client page
    client: {
      back: '← Back', backHome: '← Back to home',
      welcome: 'Welcome,', subtitle: 'Book a ride or track your active trips.',
      totalRides: 'Total rides', completed: 'Completed',
      active: 'Active rides', completedSection: 'Completed', cancelledSection: 'Cancelled',
      noRides: 'No rides yet', noRidesHint: 'Book your first ride using the form',
      bookError: 'Failed to book ride. Please try again.',
      cancelError: 'Could not cancel ride. Please try again.',
      rateError: 'Could not submit rating. Please try again.',
      notifyAccepted: 'Driver is on the way!', notifyArrived: 'Your driver has arrived!', notifyStarted: 'Your ride has started', notifyCompleted: 'Ride completed!', notifyCancelled: 'Your ride was cancelled.',
      newRide: 'Book new ride', hideForm: 'Hide form', loadMore: 'Load more',
    },
    // Driver page
    driver: {
      back: '← Back', online: 'Online', offline: 'Offline', onlineError: 'Could not update online status',
      subtitle: 'Accept new rides and track your earnings.',
      totalRides: 'Total rides', earned: 'Earned', available: 'Available now',
      availableTitle: 'Available rides', currentRide: 'Current ride',
      noRides: 'No new rides right now', noRidesHint: 'Waiting for new requests',
      myRides: 'My rides',
      acceptError: 'Could not accept ride — it may have been taken already.',
      completeError: 'Could not complete ride.',
      cancelError: 'Could not cancel ride. Please try again.',
      geoError: 'GPS unavailable. Your location will not be updated.',
      rateClientError: 'Could not submit rating. Please try again.',
      notifyNewRide: 'New ride request!',
      loadMore: 'Load more',
      offlineMsg: 'You are offline.',
      offlineHint: 'Toggle online above to start accepting rides.',
    },
    // Ride form
    rideForm: {
      title: 'Book your ride',
      pickup: 'Pickup location', dropoff: 'Drop-off location',
      distLabel: 'Distance (km)', distHint: '— default 5 km', distPlaceholder: 'e.g. 8.5',
      perKm: '€2.00/km', confirm: 'Confirm ride', booking: 'Booking…',
    },
    // Ride card
    rideCard: {
      rideNum: 'Ride #',
      status: { NEW: 'Looking for driver', ACCEPTED: 'On the way', ARRIVED: 'Driver arrived', IN_PROGRESS: 'Trip in progress', COMPLETED: 'Completed', CANCELLED: 'Cancelled' },
      accept: 'Accept ride', arrive: "I've arrived", start: 'Start ride', complete: 'Complete ride ✓', cancel: 'Cancel ride',
      cancelConfirmText: 'Are you sure you want to cancel this ride?',
      cancelConfirm: 'Yes, cancel', cancelDeny: 'No, keep it',
      driverPhone: 'Driver phone', clientPhone: 'Passenger phone',
      eta: 'Driver arrives in ~{min} min',
      rateRide: 'Rate this ride', yourRating: 'Your rating',
      reviewPlaceholder: 'Leave a review (optional)', submitRating: 'Submit rating',
      ratePassenger: 'Rate the passenger', yourRatingOfPassenger: 'Your rating of the passenger',
    },
    // Users list
    usersList: {
      riders: 'Riders', drivers: 'Drivers',
      registeredRiders: 'riders registered', registeredDrivers: 'drivers registered',
      bookBtn: 'Book a ride', driveBtn: 'Become a driver',
      noRiders: 'No riders registered yet', noDrivers: 'No drivers registered yet',
      loading: 'Loading…', back: '← Back to home',
    },
    // Help
    help: {
      title: 'Help Center', subtitle: 'Find answers to the most common questions below.',
      back: '← Back to home', soon: 'More content coming soon…',
      sections: [
        { icon: '🚕', title: 'How to book a ride',     desc: 'Click "Register", enter your contact details, then fill in your pickup and destination to book a ride instantly.' },
        { icon: '🚗', title: 'How to become a driver',  desc: 'Click "Sign in", enter your details and start accepting ride requests from passengers near you.' },
        { icon: '💳', title: 'Payment',                 desc: 'We accept card and cash payments. The price is calculated upfront before you confirm your ride.' },
        { icon: '📞', title: 'Contact support',         desc: 'Having trouble? Reach out to our support team and we will get back to you as soon as possible.' },
      ],
    },
    // Greeting
    greeting: { morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening' },
    // Profile
    profile: {
      back: '← Back', title: 'Profile',
      accountSection: 'Account', name: 'Name', email: 'Email', role: 'Role', phone: 'Phone', phonePlaceholder: '+1234567890', phoneBtn: 'Save', phoneSaved: 'Phone saved', phoneError: 'Could not save phone number. Please try again.',
      passwordSection: 'Change password',
      oldPassword: 'Old password', newPassword: 'New password', confirmPassword: 'Repeat new password',
      updateBtn: 'Update password', updating: 'Updating…',
      successMsg: 'Your password has been successfully changed and a confirmation has been sent to your email. If this was not you, please contact technical support.',
      errFill: 'Please fill in all fields.',
      errMatch: 'New passwords do not match.',
      errLength: 'New password must be at least 6 characters.',
      errGeneral: 'Something went wrong. Please try again.',
      confirmTitle: 'Change password?',
      confirmText: 'Are you sure you want to change your account password?',
      confirmYes: 'Yes', confirmNo: 'No',
    },
    // Riders page
    ridersPage: {
      badge: 'For passengers', title: 'Get a ride in seconds',
      subtitle: 'Enter your route, see the price, and a driver is on the way. No hidden fees.',
      bookBtn: 'Book a ride now', pricingTitle: 'Simple pricing',
      pricingDesc: 'Price is shown before you confirm. What you see is what you pay.',
      howTitle: 'How it works',
      steps: [
        { title: 'Enter your destination', desc: 'Type your pickup and drop-off address. See the price before confirming.' },
        { title: 'Confirm your ride',       desc: 'Review the price and distance, then tap Confirm. No surprises.' },
        { title: 'Driver arrives',          desc: 'A nearby driver accepts and heads your way. Track the status in real time.' },
        { title: 'Arrive safely',           desc: 'Reach your destination. Payment is calculated automatically.' },
      ],
      faqTitle: 'Frequently asked questions',
      faqs: [
        { q: 'Do I need an account to book?',    a: 'No - you can fill in your route and see the price without logging in. You only need to sign in when confirming the booking.' },
        { q: 'How is the price calculated?',     a: 'Price = distance in km x €2.00. The distance is calculated automatically from your addresses.' },
        { q: 'Can I cancel a ride?',             a: 'Yes - you can cancel any ride that has not been completed yet. Just click Cancel ride on the ride card.' },
        { q: 'What if no driver is available?',  a: 'Your ride stays in the queue. Drivers see all open requests and can accept at any time.' },
      ],
      ctaText: 'Ready to go?', ctaBtn: 'Book your first ride',
    },
    // Drivers page
    driversPage: {
      badge: 'For drivers', title: 'Drive on your own terms',
      subtitle: 'Set your own hours, accept rides when you want, and get paid weekly.',
      driveBtn: 'Start driving today',
      perks: [
        { title: 'Flexible hours',       desc: 'Work whenever you want. No minimum hours, no schedule.' },
        { title: 'Weekly payout',        desc: 'Earnings are calculated automatically and paid out weekly.' },
        { title: 'Simple app',           desc: 'Accept a ride with one tap. No complicated setup.' },
        { title: 'Transparent earnings', desc: 'You see exactly how much you earn per ride before accepting.' },
      ],
      earningsTitle: 'Example earnings',
      earningsDesc: 'A 10 km ride earns you €20.00. Complete 5 rides a day and earn €100+.',
      howTitle: 'How to get started',
      steps: [
        { title: 'Create a driver account', desc: 'Sign up and select the Driver role. Takes less than a minute.' },
        { title: 'Go online',               desc: 'Open the driver dashboard. You are online and visible to passengers immediately.' },
        { title: 'Accept rides',            desc: 'New ride requests appear in real time. Accept the ones you want.' },
        { title: 'Complete and earn',       desc: 'Mark the ride as completed and your earnings are updated instantly.' },
      ],
      faqTitle: 'Frequently asked questions',
      faqs: [
        { q: 'Do I need a special license?',       a: 'You need a valid driver license. Requirements may vary by country - check local regulations.' },
        { q: 'How much can I earn?',               a: 'Earnings depend on how many rides you complete. Each ride pays €2.00 per km of distance.' },
        { q: 'Can I choose which rides to accept?', a: 'Yes - you see the pickup and drop-off before accepting. Accept only the rides that suit you.' },
        { q: 'What if a passenger cancels?',       a: 'If a ride is cancelled before you start driving, no penalty. You simply return to the available pool.' },
      ],
      ctaText: 'Ready to start earning?', ctaBtn: 'Create driver account',
    },
    // About page
    aboutPage: {
      badge: 'About HayTaxi', title: 'Taxi that just works',
      subtitle: 'HayTaxi is a simple, no-nonsense taxi platform. No surge pricing, no complicated onboarding, no hidden fees. Just a ride from A to B at a fair price.',
      stats: [
        { value: '€2.00', label: 'Per km - fixed rate' },
        { value: '< 30s', label: 'Time to book a ride' },
        { value: '100%',  label: 'Fare goes to the driver' },
      ],
      missionTitle: 'Our mission',
      mission1: 'We built HayTaxi because existing platforms had become too complicated - too many options, too many fees, too much friction for both passengers and drivers.',
      mission2: 'Our goal is simple: connect passengers and drivers with as little friction as possible. No surge pricing, no commission for drivers, no account required just to see a price.',
      valuesTitle: 'What we stand for',
      values: [
        { title: 'Transparent pricing', desc: 'Price is shown before you confirm. No surge pricing, no hidden fees.' },
        { title: 'Simple by design',    desc: 'Book a ride in under 30 seconds. No unnecessary steps.' },
        { title: 'Fair for drivers',    desc: 'Drivers keep 100% of the fare. No commission cuts.' },
      ],
      techTitle: 'Built with modern tech',
      techDesc: 'HayTaxi is an MVP project built with a full production-grade stack - not a toy prototype.',
      ctaTitle: 'Ready to try it?', ctaDesc: 'Book a ride as a passenger or sign up as a driver.',
      ctaBook: 'Book a ride', ctaDrive: 'Become a driver',
    },
    admin: {
      title: 'Admin Panel', back: '← Back',
      tabUsers: 'Users', tabRides: 'Rides',
      block: 'Block', unblock: 'Unblock', cancelRide: 'Cancel',
      blocked: 'Blocked', active: 'Active',
      role: 'Role', status: 'Status', name: 'Name', username: 'Username',
      noUsers: 'No users found', noRides: 'No rides found',
      confirmBlock: 'Block this user?', confirmCancel: 'Cancel this ride?',
      yes: 'Yes', no: 'No',
    },
  },

  fr: {
    nav: { riders: 'Passagers', drivers: 'Chauffeurs', about: 'À propos', help: 'Aide', signIn: 'Connexion', register: "S'inscrire", signOut: 'Déconnexion', profile: 'Profil' },
    notifications: {
      title: 'Notifications', markAllRead: 'Tout marquer comme lu', empty: 'Aucune notification pour le moment',
      types: {
        NEW_RIDE: 'Nouvelle demande de course disponible',
        RIDE_ACCEPTED: 'Le chauffeur est en route !',
        RIDE_ARRIVED: 'Le chauffeur est arrivé',
        RIDE_STARTED: 'Votre course a commencé',
        RIDE_COMPLETED: 'Course terminée',
        RIDE_CANCELLED: 'La course a été annulée',
      },
    },
    validation: { required: 'Ce champ est requis.', email: 'Veuillez saisir une adresse e-mail valide.' },
    footer: {
      copy: '© 2026 HayTaxi. Tous droits réservés.',
      tagline: 'Des trajets rapides, sûrs et fiables — quand vous en avez besoin.',
      company: 'Entreprise', about: 'À propos', help: 'Aide',
      ridersCol: 'Passagers', bookRide: 'Réserver', howItWorks: 'Comment ça marche',
      driversCol: 'Chauffeurs', becomeDriver: 'Devenir chauffeur',
    },
    landing: {
      badge: 'Rapide · Sûr · Fiable',
      h1a: "L'appli taxi", h1b: 'qui vous emmène', h1c: 'à destination.',
      subtitle: 'Réservez en quelques secondes, suivez votre chauffeur en temps réel et arrivez en toute sécurité.',
      bookBtn: 'Réserver', driveBtn: 'Devenir chauffeur',
      stat1: 'Courses effectuées', stat2: 'Chauffeurs actifs', stat3: 'Note moyenne',
      featuresTitle: 'Pourquoi choisir HayTaxi ?',
      featuresSubtitle: 'Tout ce dont vous avez besoin pour un trajet agréable.',
      features: [
        { title: 'Prise en charge rapide', desc: 'Votre chauffeur arrive en quelques minutes. Mise en relation en temps réel.' },
        { title: 'Sûr et fiable',           desc: 'Toutes les courses sont suivies. Prix transparent sans frais cachés.' },
        { title: 'Paiement facile',         desc: 'Payez par carte ou en espèces. Prix affiché avant confirmation.' },
      ],
      howBadge: 'Comment ça marche',
      howTitle: 'Réserver un trajet\nprend 30 secondes.',
      steps: [
        { title: 'Entrez votre destination', desc: 'Tapez où vous voulez aller et voyez le prix instantanément.' },
        { title: 'Confirmez votre course',   desc: 'Un chauffeur proche accepte votre demande en quelques secondes.' },
        { title: 'Profitez du trajet',       desc: 'Suivez votre chauffeur en direct et arrivez en toute sécurité.' },
      ],
      bookNow: 'Réserver maintenant — gratuit',
      priceLabel: 'Estimation en direct', distLabel: 'Distance', durLabel: 'Durée', priceTag: 'Prix',
      confirmBook: 'Confirmer la réservation',
      driverTitle: 'Roulez avec nous.\nGagnez à votre rythme.',
      driverDesc: "Rejoignez des centaines de chauffeurs qui gagnent déjà avec HayTaxi. Fixez vos propres horaires et soyez payé chaque semaine.",
      startDriving: 'Commencer à conduire', learnMore: 'En savoir plus',
      driverPerks: [
        ['💰', 'Paiements hebdomadaires', 'Directement sur votre compte'],
        ['📱', 'Application simple',      'Acceptez en un tap'],
        ['🗓️', 'Horaires flexibles',      'Travaillez quand vous voulez'],
        ['⭐', 'Top évalué',              'Gagnez des bonus'],
      ],
    },
    auth: {
      back: '← Retour',
      loginTitle: 'Bon retour',
      registerTitle: 'Créer un compte',
      loginSubtitle: 'Connectez-vous pour continuer',
      joinAsRider: 'Rejoindre comme passager',
      joinAsDriver: 'Rejoindre comme chauffeur',
      namePlaceholder: 'Nom complet',
      usernamePlaceholder: 'E-mail / identifiant',
      emailPlaceholder: 'E-mail',
      passwordPlaceholder: 'Mot de passe',
      roleRider: 'Passager',
      roleDriver: 'Chauffeur',
      forgotPassword: 'Mot de passe oublié ?',
      loading: 'Veuillez patienter…',
      signIn: 'Se connecter',
      createAccount: 'Créer un compte',
      noAccount: 'Pas de compte ?',
      hasAccount: 'Vous avez déjà un compte ?',
      signUp: "S'inscrire",
      passwordMinLength: 'Le mot de passe doit comporter au moins 6 caractères.',
      genericError: "Quelque chose s'est mal passé. Veuillez réessayer.",
      checkEmailTitle: 'Vérifiez votre e-mail',
      checkEmailBefore: 'Nous avons envoyé un lien de confirmation à ',
      checkEmailAfter: '. Ouvrez-le pour activer votre compte, puis connectez-vous.',
      backToSignIn: 'Retour à la connexion',
      resendLink: "Vous n'avez pas reçu l'e-mail ? Renvoyer la confirmation",
      resendSent: 'E-mail de confirmation renvoyé.',
      resendError: "Impossible de renvoyer l'e-mail. Veuillez réessayer plus tard.",
    },
    verifyEmail: {
      title: 'Confirmez votre e-mail',
      verifying: 'Confirmation de votre e-mail…',
      successMsg: 'Votre e-mail a été confirmé. Vous pouvez maintenant vous connecter.',
      errorMsg: 'Ce lien de confirmation est invalide ou a expiré.',
      backToSignIn: 'Retour à la connexion',
    },
    forgotModal: {
      title: 'Mot de passe oublié ?',
      subtitle: 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation du mot de passe.',
      emailPlaceholder: 'votre@email.com',
      cancel: 'Annuler',
      send: 'Envoyer le lien',
      sending: 'Envoi…',
      successBefore: 'Nous avons envoyé un lien de réinitialisation à ',
      successAfter: ". Ouvrez-le pour définir un nouveau mot de passe. Le lien est valable 1 heure.",
      gotIt: "D'accord",
      genericError: "Quelque chose s'est mal passé. Veuillez réessayer.",
    },
    resetPassword: {
      title: 'Définir un nouveau mot de passe',
      subtitle: 'Entrez un nouveau mot de passe pour votre compte.',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Répéter le nouveau mot de passe',
      submitBtn: 'Définir le mot de passe',
      updating: 'Mise à jour…',
      successMsg: 'Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter avec.',
      backToSignIn: 'Retour à la connexion',
      errFill: 'Veuillez remplir tous les champs.',
      errMatch: 'Les mots de passe ne correspondent pas.',
      errLength: 'Le mot de passe doit contenir au moins 6 caractères.',
      errGeneral: "Une erreur s'est produite. Veuillez réessayer.",
    },
    booking: {
      subtitle: 'Remplissez les détails et confirmez votre course.',
      signInToBook: 'Se connecter pour réserver',
      loginHint: 'Vous devrez vous connecter avant de confirmer',
      calculating: 'Calcul en cours…',
      distanceError: 'Impossible de calculer la distance. Entrez-la manuellement.',
    },
    client: {
      back: '← Retour', backHome: '← Accueil',
      welcome: 'Bienvenue,', subtitle: 'Réservez une course ou suivez vos trajets actifs.',
      totalRides: 'Courses totales', completed: 'Terminées',
      active: 'Courses actives', completedSection: 'Terminées', cancelledSection: 'Annulées',
      noRides: 'Pas encore de courses', noRidesHint: 'Réservez votre première course',
      bookError: 'Échec de la réservation. Veuillez réessayer.',
      cancelError: 'Impossible d\'annuler la course. Veuillez réessayer.',
      rateError: "Impossible d'envoyer la note. Veuillez réessayer.",
      notifyAccepted: 'Le chauffeur est en route !', notifyArrived: 'Votre chauffeur est arrivé !', notifyStarted: 'Votre course a commencé', notifyCompleted: 'Course terminée !', notifyCancelled: 'Votre course a été annulée.',
      newRide: 'Réserver une course', hideForm: 'Masquer le formulaire', loadMore: 'Voir plus',
    },
    driver: {
      back: '← Retour', online: 'En ligne', offline: 'Hors ligne', onlineError: 'Impossible de mettre à jour le statut',
      subtitle: 'Acceptez des courses et suivez vos gains.',
      totalRides: 'Courses totales', earned: 'Gagné', available: 'Disponibles',
      availableTitle: 'Courses disponibles', currentRide: 'Course en cours',
      noRides: 'Pas de nouvelles courses', noRidesHint: 'En attente de nouvelles demandes',
      myRides: 'Mes courses',
      acceptError: "Impossible d'accepter - la course a peut-etre ete prise.",
      completeError: 'Impossible de terminer la course.',
      cancelError: "Impossible d'annuler la course. Veuillez réessayer.",
      geoError: 'GPS indisponible. Votre position ne sera pas mise à jour.',
      rateClientError: "Impossible d'envoyer la note. Veuillez réessayer.",
      notifyNewRide: 'Nouvelle demande de course !',
      loadMore: 'Voir plus',
      offlineMsg: 'Vous êtes hors ligne.',
      offlineHint: 'Passez en ligne ci-dessus pour accepter des courses.',
    },
    rideForm: {
      title: 'Réservez votre course',
      pickup: 'Lieu de prise en charge', dropoff: 'Lieu de dépose',
      distLabel: 'Distance (km)', distHint: '— 5 km par défaut', distPlaceholder: 'ex. 8.5',
      perKm: '€2.00/km', confirm: 'Confirmer la course', booking: 'Réservation…',
    },
    rideCard: {
      rideNum: 'Course #',
      status: { NEW: 'Recherche chauffeur', ACCEPTED: 'En route', ARRIVED: 'Chauffeur arrivé', IN_PROGRESS: 'Course en cours', COMPLETED: 'Terminée', CANCELLED: 'Annulée' },
      accept: 'Accepter', arrive: 'Je suis arrivé', start: 'Démarrer la course', complete: 'Terminer ✓', cancel: 'Annuler',
      cancelConfirmText: 'Voulez-vous vraiment annuler cette course ?',
      cancelConfirm: 'Oui, annuler', cancelDeny: 'Non, garder',
      driverPhone: 'Tél. chauffeur', clientPhone: 'Tél. passager',
      eta: 'Arrivée dans ~{min} min',
      rateRide: 'Évaluer cette course', yourRating: 'Votre note',
      reviewPlaceholder: 'Laissez un avis (facultatif)', submitRating: 'Envoyer la note',
      ratePassenger: 'Évaluer le passager', yourRatingOfPassenger: 'Votre note du passager',
    },
    usersList: {
      riders: 'Passagers', drivers: 'Chauffeurs',
      registeredRiders: 'passagers inscrits', registeredDrivers: 'chauffeurs inscrits',
      bookBtn: 'Réserver', driveBtn: 'Devenir chauffeur',
      noRiders: 'Aucun passager inscrit', noDrivers: 'Aucun chauffeur inscrit',
      loading: 'Chargement…', back: '← Accueil',
    },
    help: {
      title: "Centre d'aide", subtitle: 'Trouvez des réponses aux questions les plus fréquentes.',
      back: '← Accueil', soon: 'Plus de contenu bientôt…',
      sections: [
        { icon: '🚕', title: 'Comment réserver',         desc: 'Cliquez sur "S\'inscrire", entrez vos coordonnées, puis renseignez votre itinéraire.' },
        { icon: '🚗', title: 'Devenir chauffeur',        desc: 'Cliquez sur "Connexion", entrez vos informations et commencez à accepter des courses.' },
        { icon: '💳', title: 'Paiement',                 desc: 'Nous acceptons les paiements par carte et en espèces. Le prix est affiché à l\'avance.' },
        { icon: '📞', title: 'Contacter le support',    desc: 'Un problème ? Contactez notre équipe, nous vous répondrons dès que possible.' },
      ],
    },
    greeting: { morning: 'Bonjour', afternoon: 'Bon après-midi', evening: 'Bonsoir' },
    profile: {
      back: '← Retour', title: 'Profil',
      accountSection: 'Compte', name: 'Nom', email: 'E-mail', role: 'Rôle', phone: 'Téléphone', phonePlaceholder: '+33612345678', phoneBtn: 'Enregistrer', phoneSaved: 'Numéro enregistré', phoneError: "Impossible d'enregistrer le numéro. Veuillez réessayer.",
      passwordSection: 'Changer le mot de passe',
      oldPassword: 'Ancien mot de passe', newPassword: 'Nouveau mot de passe', confirmPassword: 'Répéter le nouveau mot de passe',
      updateBtn: 'Mettre à jour', updating: 'Mise à jour…',
      successMsg: 'Votre mot de passe a été modifié avec succès et une confirmation a été envoyée à votre e-mail. Si ce n\'était pas vous, contactez le support.',
      errFill: 'Veuillez remplir tous les champs.',
      errMatch: 'Les mots de passe ne correspondent pas.',
      errLength: 'Le nouveau mot de passe doit contenir au moins 6 caractères.',
      errGeneral: 'Une erreur s\'est produite. Veuillez réessayer.',
      confirmTitle: 'Changer le mot de passe ?',
      confirmText: 'Êtes-vous sûr de vouloir changer votre mot de passe ?',
      confirmYes: 'Oui', confirmNo: 'Non',
    },
    ridersPage: {
      badge: 'Pour les passagers', title: 'Une course en quelques secondes',
      subtitle: 'Entrez votre itinéraire, voyez le prix, et un chauffeur est en route. Sans frais cachés.',
      bookBtn: 'Réserver maintenant', pricingTitle: 'Tarif simple',
      pricingDesc: 'Le prix est affiché avant confirmation. Ce que vous voyez est ce que vous payez.',
      howTitle: 'Comment ça marche',
      steps: [
        { title: 'Entrez votre destination', desc: 'Tapez votre adresse de départ et d\'arrivée. Voyez le prix avant de confirmer.' },
        { title: 'Confirmez votre course',   desc: 'Vérifiez le prix et la distance, puis appuyez sur Confirmer.' },
        { title: 'Le chauffeur arrive',      desc: 'Un chauffeur proche accepte et arrive. Suivez le statut en temps réel.' },
        { title: 'Arrivez en sécurité',      desc: 'Atteignez votre destination. Le paiement est calculé automatiquement.' },
      ],
      faqTitle: 'Questions fréquentes',
      faqs: [
        { q: 'Ai-je besoin d\'un compte pour réserver ?', a: 'Non - vous pouvez voir le prix sans vous connecter. Vous devez vous connecter uniquement pour confirmer.' },
        { q: 'Comment le prix est-il calculé ?',          a: 'Prix = distance en km x €2.00. La distance est calculée automatiquement.' },
        { q: 'Puis-je annuler une course ?',              a: 'Oui - vous pouvez annuler toute course non terminée. Cliquez sur Annuler sur la carte.' },
        { q: 'Que faire si aucun chauffeur n\'est disponible ?', a: 'Votre course reste dans la file. Les chauffeurs voient toutes les demandes.' },
      ],
      ctaText: 'Prêt à partir ?', ctaBtn: 'Réservez votre première course',
    },
    driversPage: {
      badge: 'Pour les chauffeurs', title: 'Conduisez selon vos conditions',
      subtitle: 'Fixez vos propres horaires, acceptez des courses quand vous voulez, et soyez payé chaque semaine.',
      driveBtn: 'Commencer à conduire',
      perks: [
        { title: 'Horaires flexibles',   desc: 'Travaillez quand vous voulez. Pas d\'heures minimum.' },
        { title: 'Paiement hebdomadaire', desc: 'Les gains sont calculés automatiquement et versés chaque semaine.' },
        { title: 'Application simple',   desc: 'Acceptez une course en un tap. Pas de configuration compliquée.' },
        { title: 'Gains transparents',   desc: 'Vous voyez exactement combien vous gagnez avant d\'accepter.' },
      ],
      earningsTitle: 'Exemple de gains',
      earningsDesc: 'Une course de 10 km vous rapporte €20.00. Faites 5 courses par jour et gagnez €100+.',
      howTitle: 'Comment commencer',
      steps: [
        { title: 'Créez un compte chauffeur', desc: 'Inscrivez-vous et sélectionnez le rôle Chauffeur. Moins d\'une minute.' },
        { title: 'Passez en ligne',           desc: 'Ouvrez le tableau de bord. Vous êtes visible pour les passagers immédiatement.' },
        { title: 'Acceptez des courses',      desc: 'Les nouvelles demandes apparaissent en temps réel.' },
        { title: 'Terminez et gagnez',        desc: 'Marquez la course comme terminée et vos gains sont mis à jour instantanément.' },
      ],
      faqTitle: 'Questions fréquentes',
      faqs: [
        { q: 'Ai-je besoin d\'un permis spécial ?',     a: 'Vous avez besoin d\'un permis de conduire valide. Les exigences varient selon le pays.' },
        { q: 'Combien puis-je gagner ?',                a: 'Les gains dépendent du nombre de courses. Chaque course rapporte €2.00 par km.' },
        { q: 'Puis-je choisir les courses à accepter ?', a: 'Oui - vous voyez le départ et l\'arrivée avant d\'accepter.' },
        { q: 'Que se passe-t-il si un passager annule ?', a: 'Pas de pénalité. Vous revenez simplement dans le pool disponible.' },
      ],
      ctaText: 'Prêt à gagner ?', ctaBtn: 'Créer un compte chauffeur',
    },
    aboutPage: {
      badge: 'À propos de HayTaxi', title: 'Le taxi qui fonctionne simplement',
      subtitle: 'HayTaxi est une plateforme de taxi simple et sans fioritures. Pas de tarification dynamique, pas de frais cachés.',
      stats: [
        { value: '€2.00', label: 'Par km - tarif fixe' },
        { value: '< 30s', label: 'Temps pour réserver' },
        { value: '100%',  label: 'Tarif pour le chauffeur' },
      ],
      missionTitle: 'Notre mission',
      mission1: 'Nous avons créé HayTaxi parce que les plateformes existantes étaient devenues trop compliquées.',
      mission2: 'Notre objectif est simple: connecter passagers et chauffeurs avec le moins de friction possible.',
      valuesTitle: 'Nos valeurs',
      values: [
        { title: 'Prix transparent', desc: 'Le prix est affiché avant confirmation. Pas de tarification dynamique.' },
        { title: 'Simple par conception', desc: 'Réservez une course en moins de 30 secondes.' },
        { title: 'Équitable pour les chauffeurs', desc: 'Les chauffeurs gardent 100% du tarif.' },
      ],
      techTitle: 'Construit avec des technologies modernes',
      techDesc: 'HayTaxi est un projet MVP construit avec une stack de production complète.',
      ctaTitle: 'Prêt à essayer ?', ctaDesc: 'Réservez une course ou inscrivez-vous comme chauffeur.',
      ctaBook: 'Réserver une course', ctaDrive: 'Devenir chauffeur',
    },
    admin: {
      title: 'Panneau Admin', back: '← Retour',
      tabUsers: 'Utilisateurs', tabRides: 'Courses',
      block: 'Bloquer', unblock: 'Débloquer', cancelRide: 'Annuler',
      blocked: 'Bloqué', active: 'Actif',
      role: 'Rôle', status: 'Statut', name: 'Nom', username: 'Identifiant',
      noUsers: 'Aucun utilisateur', noRides: 'Aucune course',
      confirmBlock: 'Bloquer cet utilisateur ?', confirmCancel: 'Annuler cette course ?',
      yes: 'Oui', no: 'Non',
    },
  },

  de: {
    nav: { riders: 'Fahrgäste', drivers: 'Fahrer', about: 'Über uns', help: 'Hilfe', signIn: 'Anmelden', register: 'Registrieren', signOut: 'Abmelden', profile: 'Profil' },
    notifications: {
      title: 'Benachrichtigungen', markAllRead: 'Alle als gelesen markieren', empty: 'Noch keine Benachrichtigungen',
      types: {
        NEW_RIDE: 'Neue Fahrtanfrage verfügbar',
        RIDE_ACCEPTED: 'Der Fahrer ist auf dem Weg!',
        RIDE_ARRIVED: 'Der Fahrer ist angekommen',
        RIDE_STARTED: 'Deine Fahrt hat begonnen',
        RIDE_COMPLETED: 'Fahrt abgeschlossen',
        RIDE_CANCELLED: 'Fahrt wurde storniert',
      },
    },
    validation: { required: 'Dieses Feld ist erforderlich.', email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.' },
    footer: {
      copy: '© 2026 HayTaxi. Alle Rechte vorbehalten.',
      tagline: 'Schnelle, sichere und zuverlässige Fahrten — wann immer Sie sie brauchen.',
      company: 'Unternehmen', about: 'Über uns', help: 'Hilfe',
      ridersCol: 'Fahrgäste', bookRide: 'Fahrt buchen', howItWorks: 'So funktioniert es',
      driversCol: 'Fahrer', becomeDriver: 'Fahrer werden',
    },
    landing: {
      badge: 'Schnell · Sicher · Zuverlässig',
      h1a: 'Die Taxi-App,', h1b: 'die Sie ans', h1c: 'Ziel bringt.',
      subtitle: 'Fahrt in Sekunden buchen, Fahrer in Echtzeit verfolgen und sicher ankommen.',
      bookBtn: 'Fahrt buchen', driveBtn: 'Fahrer werden',
      stat1: 'Abgeschlossene Fahrten', stat2: 'Aktive Fahrer', stat3: 'Durchschnittsbewertung',
      featuresTitle: 'Warum HayTaxi?',
      featuresSubtitle: 'Alles, was Sie für eine stressfreie Fahrt brauchen.',
      features: [
        { title: 'Schnelle Abholung',   desc: 'Ihr Fahrer kommt in Minuten. Echtzeit-Matching mit Fahrern in der Nähe.' },
        { title: 'Sicher & zuverlässig', desc: 'Alle Fahrten werden verfolgt. Transparente Preise ohne versteckte Gebühren.' },
        { title: 'Einfache Zahlung',    desc: 'Zahlen Sie per Karte oder bar. Preis wird vor Bestätigung angezeigt.' },
      ],
      howBadge: 'So funktioniert es',
      howTitle: 'Eine Fahrt buchen\ndauert 30 Sekunden.',
      steps: [
        { title: 'Ziel eingeben',       desc: 'Tippen Sie Ihr Ziel ein und sehen Sie den Preis sofort.' },
        { title: 'Fahrt bestätigen',    desc: 'Ein Fahrer in der Nähe nimmt Ihre Anfrage in Sekunden an.' },
        { title: 'Fahrt genießen',      desc: 'Verfolgen Sie Ihren Fahrer live und kommen Sie sicher an.' },
      ],
      bookNow: 'Jetzt buchen — kostenlos',
      priceLabel: 'Live-Preisschätzung', distLabel: 'Entfernung', durLabel: 'Dauer', priceTag: 'Preis',
      confirmBook: 'Bestätigen & buchen',
      driverTitle: 'Fahren Sie mit uns.\nVerdienen Sie nach Ihrem Plan.',
      driverDesc: 'Schließen Sie sich Hunderten von Fahrern an, die bereits mit HayTaxi verdienen. Setzen Sie Ihre eigenen Zeiten und werden Sie wöchentlich bezahlt.',
      startDriving: 'Jetzt fahren', learnMore: 'Mehr erfahren',
      driverPerks: [
        ['💰', 'Wöchentliche Auszahlung', 'Direkt auf Ihr Konto'],
        ['📱', 'Einfache App',            'Mit einem Tap annehmen'],
        ['🗓️', 'Flexible Zeiten',         'Arbeiten Sie wann Sie wollen'],
        ['⭐', 'Top bewertet',            'Boni verdienen'],
      ],
    },
    auth: {
      back: '← Zurück',
      loginTitle: 'Willkommen zurück',
      registerTitle: 'Konto erstellen',
      loginSubtitle: 'Anmelden um fortzufahren',
      joinAsRider: 'Als Fahrgast registrieren',
      joinAsDriver: 'Als Fahrer registrieren',
      namePlaceholder: 'Vollständiger Name',
      usernamePlaceholder: 'E-Mail / Benutzername',
      emailPlaceholder: 'E-Mail',
      passwordPlaceholder: 'Passwort',
      roleRider: 'Fahrgast',
      roleDriver: 'Fahrer',
      forgotPassword: 'Passwort vergessen?',
      loading: 'Bitte warten…',
      signIn: 'Anmelden',
      createAccount: 'Konto erstellen',
      noAccount: 'Noch kein Konto?',
      hasAccount: 'Bereits ein Konto?',
      signUp: 'Registrieren',
      passwordMinLength: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
      genericError: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
      checkEmailTitle: 'Überprüfen Sie Ihre E-Mail',
      checkEmailBefore: 'Wir haben einen Bestätigungslink an ',
      checkEmailAfter: ' gesendet. Öffnen Sie ihn, um Ihr Konto zu aktivieren, und melden Sie sich dann an.',
      backToSignIn: 'Zurück zur Anmeldung',
      resendLink: 'Keine E-Mail erhalten? Bestätigung erneut senden',
      resendSent: 'Bestätigungs-E-Mail wurde erneut gesendet.',
      resendError: 'Die E-Mail konnte nicht erneut gesendet werden. Bitte später erneut versuchen.',
    },
    verifyEmail: {
      title: 'Bestätigen Sie Ihre E-Mail',
      verifying: 'E-Mail wird bestätigt…',
      successMsg: 'Ihre E-Mail wurde bestätigt. Sie können sich jetzt anmelden.',
      errorMsg: 'Dieser Bestätigungslink ist ungültig oder abgelaufen.',
      backToSignIn: 'Zurück zur Anmeldung',
    },
    forgotModal: {
      title: 'Passwort vergessen?',
      subtitle: 'Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.',
      emailPlaceholder: 'ihre@email.com',
      cancel: 'Abbrechen',
      send: 'Link senden',
      sending: 'Senden…',
      successBefore: 'Wir haben einen Link zum Zurücksetzen des Passworts an ',
      successAfter: ' gesendet. Öffnen Sie ihn, um ein neues Passwort festzulegen. Der Link ist 1 Stunde gültig.',
      gotIt: 'Verstanden',
      genericError: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    },
    resetPassword: {
      title: 'Neues Passwort festlegen',
      subtitle: 'Geben Sie ein neues Passwort für Ihr Konto ein.',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Neues Passwort wiederholen',
      submitBtn: 'Neues Passwort festlegen',
      updating: 'Wird aktualisiert…',
      successMsg: 'Ihr Passwort wurde geändert. Sie können sich jetzt damit anmelden.',
      backToSignIn: 'Zurück zur Anmeldung',
      errFill: 'Bitte alle Felder ausfüllen.',
      errMatch: 'Die Passwörter stimmen nicht überein.',
      errLength: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
      errGeneral: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    },
    booking: {
      subtitle: 'Details eingeben und Fahrt bestätigen.',
      signInToBook: 'Anmelden zum Buchen',
      loginHint: 'Sie werden vor der Bestätigung zur Anmeldung aufgefordert',
      calculating: 'Wird berechnet…',
      distanceError: 'Entfernung konnte nicht berechnet werden. Bitte manuell eingeben.',
    },
    client: {
      back: '← Zurück', backHome: '← Startseite',
      welcome: 'Willkommen,', subtitle: 'Fahrt buchen oder aktive Fahrten verfolgen.',
      totalRides: 'Fahrten gesamt', completed: 'Abgeschlossen',
      active: 'Aktive Fahrten', completedSection: 'Abgeschlossen', cancelledSection: 'Storniert',
      noRides: 'Noch keine Fahrten', noRidesHint: 'Buchen Sie Ihre erste Fahrt',
      bookError: 'Buchung fehlgeschlagen. Bitte erneut versuchen.',
      cancelError: 'Fahrt konnte nicht storniert werden. Bitte erneut versuchen.',
      rateError: 'Bewertung konnte nicht gesendet werden. Bitte erneut versuchen.',
      notifyAccepted: 'Der Fahrer ist unterwegs!', notifyArrived: 'Ihr Fahrer ist angekommen!', notifyStarted: 'Ihre Fahrt hat begonnen', notifyCompleted: 'Fahrt abgeschlossen!', notifyCancelled: 'Ihre Fahrt wurde storniert.',
      newRide: 'Neue Fahrt buchen', hideForm: 'Formular ausblenden', loadMore: 'Mehr laden',
    },
    driver: {
      back: '← Zurück', online: 'Online', offline: 'Offline', onlineError: 'Status konnte nicht aktualisiert werden',
      subtitle: 'Fahrten annehmen und Verdienst verfolgen.',
      totalRides: 'Fahrten gesamt', earned: 'Verdient', available: 'Verfügbar',
      availableTitle: 'Verfügbare Fahrten', currentRide: 'Aktuelle Fahrt',
      noRides: 'Keine neuen Fahrten', noRidesHint: 'Warte auf neue Anfragen',
      myRides: 'Meine Fahrten',
      acceptError: 'Fahrt konnte nicht angenommen werden - moglicherweise bereits vergeben.',
      completeError: 'Fahrt konnte nicht abgeschlossen werden.',
      cancelError: 'Fahrt konnte nicht storniert werden. Bitte erneut versuchen.',
      geoError: 'GPS nicht verfügbar. Ihr Standort wird nicht aktualisiert.',
      rateClientError: 'Bewertung konnte nicht gesendet werden. Bitte erneut versuchen.',
      notifyNewRide: 'Neue Fahrtanfrage!',
      loadMore: 'Mehr laden',
      offlineMsg: 'Sie sind offline.',
      offlineHint: 'Gehen Sie oben online, um Fahrten anzunehmen.',
    },
    rideForm: {
      title: 'Fahrt buchen',
      pickup: 'Abholort', dropoff: 'Zielort',
      distLabel: 'Entfernung (km)', distHint: '— Standard 5 km', distPlaceholder: 'z.B. 8.5',
      perKm: '€2.00/km', confirm: 'Fahrt bestätigen', booking: 'Buchen…',
    },
    rideCard: {
      rideNum: 'Fahrt #',
      status: { NEW: 'Suche Fahrer', ACCEPTED: 'Unterwegs', ARRIVED: 'Fahrer angekommen', IN_PROGRESS: 'Fahrt läuft', COMPLETED: 'Abgeschlossen', CANCELLED: 'Storniert' },
      accept: 'Annehmen', arrive: 'Angekommen', start: 'Fahrt starten', complete: 'Abschließen ✓', cancel: 'Stornieren',
      cancelConfirmText: 'Möchten Sie diese Fahrt wirklich stornieren?',
      cancelConfirm: 'Ja, stornieren', cancelDeny: 'Nein, behalten',
      driverPhone: 'Fahrer-Telefon', clientPhone: 'Fahrgast-Telefon',
      eta: 'Fahrer kommt in ~{min} Min',
      rateRide: 'Fahrt bewerten', yourRating: 'Ihre Bewertung',
      reviewPlaceholder: 'Bewertung schreiben (optional)', submitRating: 'Bewertung absenden',
      ratePassenger: 'Fahrgast bewerten', yourRatingOfPassenger: 'Ihre Bewertung des Fahrgasts',
    },
    usersList: {
      riders: 'Fahrgäste', drivers: 'Fahrer',
      registeredRiders: 'Fahrgäste registriert', registeredDrivers: 'Fahrer registriert',
      bookBtn: 'Fahrt buchen', driveBtn: 'Fahrer werden',
      noRiders: 'Noch keine Fahrgäste registriert', noDrivers: 'Noch keine Fahrer registriert',
      loading: 'Laden…', back: '← Startseite',
    },
    help: {
      title: 'Hilfecenter', subtitle: 'Antworten auf die häufigsten Fragen.',
      back: '← Startseite', soon: 'Weitere Inhalte folgen in Kürze…',
      sections: [
        { icon: '🚕', title: 'Fahrt buchen',           desc: 'Klicken Sie auf "Registrieren", geben Sie Ihre Kontaktdaten ein und füllen Sie das Formular aus.' },
        { icon: '🚗', title: 'Fahrer werden',          desc: 'Klicken Sie auf "Anmelden", geben Sie Ihre Daten ein und nehmen Sie Fahrten an.' },
        { icon: '💳', title: 'Zahlung',                desc: 'Wir akzeptieren Karten- und Barzahlung. Der Preis wird vor Bestätigung angezeigt.' },
        { icon: '📞', title: 'Support kontaktieren',   desc: 'Problem? Wenden Sie sich an unser Support-Team.' },
      ],
    },
    greeting: { morning: 'Guten Morgen', afternoon: 'Guten Tag', evening: 'Guten Abend' },
    profile: {
      back: '← Zurück', title: 'Profil',
      accountSection: 'Konto', name: 'Name', email: 'E-Mail', role: 'Rolle', phone: 'Telefon', phonePlaceholder: '+491234567890', phoneBtn: 'Speichern', phoneSaved: 'Nummer gespeichert', phoneError: 'Nummer konnte nicht gespeichert werden. Bitte erneut versuchen.',
      passwordSection: 'Passwort ändern',
      oldPassword: 'Altes Passwort', newPassword: 'Neues Passwort', confirmPassword: 'Neues Passwort wiederholen',
      updateBtn: 'Passwort aktualisieren', updating: 'Wird aktualisiert…',
      successMsg: 'Ihr Passwort wurde erfolgreich geändert und eine Bestätigung wurde an Ihre E-Mail gesendet. Falls Sie das nicht waren, kontaktieren Sie den Support.',
      errFill: 'Bitte alle Felder ausfüllen.',
      errMatch: 'Die neuen Passwörter stimmen nicht überein.',
      errLength: 'Das neue Passwort muss mindestens 6 Zeichen lang sein.',
      errGeneral: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      confirmTitle: 'Passwort ändern?',
      confirmText: 'Möchten Sie Ihr Kontopasswort wirklich ändern?',
      confirmYes: 'Ja', confirmNo: 'Nein',
    },
    ridersPage: {
      badge: 'Für Fahrgäste', title: 'Eine Fahrt in Sekunden',
      subtitle: 'Route eingeben, Preis sehen, Fahrer ist unterwegs. Keine versteckten Gebühren.',
      bookBtn: 'Jetzt buchen', pricingTitle: 'Einfache Preise',
      pricingDesc: 'Der Preis wird vor Bestätigung angezeigt. Was Sie sehen, zahlen Sie.',
      howTitle: 'So funktioniert es',
      steps: [
        { title: 'Ziel eingeben',       desc: 'Start- und Zieladresse eingeben. Preis sofort sehen.' },
        { title: 'Fahrt bestätigen',    desc: 'Preis prüfen und auf Bestätigen tippen.' },
        { title: 'Fahrer kommt',        desc: 'Ein Fahrer nimmt an und ist auf dem Weg.' },
        { title: 'Sicher ankommen',     desc: 'Ziel erreichen. Zahlung wird automatisch berechnet.' },
      ],
      faqTitle: 'Häufige Fragen',
      faqs: [
        { q: 'Brauche ich ein Konto zum Buchen?',   a: 'Nein - Route eingeben und Preis sehen ohne Anmeldung. Anmeldung nur bei Bestätigung.' },
        { q: 'Wie wird der Preis berechnet?',       a: 'Preis = Entfernung in km x €2.00. Entfernung wird automatisch berechnet.' },
        { q: 'Kann ich eine Fahrt stornieren?',     a: 'Ja - jede nicht abgeschlossene Fahrt kann storniert werden.' },
        { q: 'Was wenn kein Fahrer verfügbar ist?', a: 'Ihre Fahrt bleibt in der Warteschlange. Fahrer sehen alle Anfragen.' },
      ],
      ctaText: 'Bereit loszufahren?', ctaBtn: 'Erste Fahrt buchen',
    },
    driversPage: {
      badge: 'Für Fahrer', title: 'Fahren zu Ihren Bedingungen',
      subtitle: 'Eigene Zeiten festlegen, Fahrten annehmen wann Sie wollen, wöchentlich bezahlt werden.',
      driveBtn: 'Jetzt starten',
      perks: [
        { title: 'Flexible Zeiten',          desc: 'Arbeiten Sie wann Sie wollen. Keine Mindeststunden.' },
        { title: 'Wöchentliche Auszahlung',  desc: 'Verdienst wird automatisch berechnet und wöchentlich ausgezahlt.' },
        { title: 'Einfache App',             desc: 'Fahrt mit einem Tap annehmen.' },
        { title: 'Transparenter Verdienst',  desc: 'Sie sehen genau wie viel Sie pro Fahrt verdienen.' },
      ],
      earningsTitle: 'Beispielverdienst',
      earningsDesc: 'Eine 10 km Fahrt bringt €20.00. 5 Fahrten pro Tag = €100+.',
      howTitle: 'So starten Sie',
      steps: [
        { title: 'Fahrerkonto erstellen', desc: 'Registrieren und Fahrer-Rolle wählen. Weniger als eine Minute.' },
        { title: 'Online gehen',          desc: 'Dashboard öffnen. Sofort für Fahrgäste sichtbar.' },
        { title: 'Fahrten annehmen',      desc: 'Neue Anfragen erscheinen in Echtzeit.' },
        { title: 'Abschließen und verdienen', desc: 'Fahrt abschließen und Verdienst wird sofort aktualisiert.' },
      ],
      faqTitle: 'Häufige Fragen',
      faqs: [
        { q: 'Brauche ich einen Sonderschein?',      a: 'Sie brauchen einen gültigen Führerschein.' },
        { q: 'Wie viel kann ich verdienen?',         a: 'Jede Fahrt zahlt €2.00 pro km.' },
        { q: 'Kann ich Fahrten auswählen?',          a: 'Ja - Sie sehen Start und Ziel vor Annahme.' },
        { q: 'Was wenn ein Fahrgast storniert?',     a: 'Keine Strafe. Sie kehren in den verfügbaren Pool zurück.' },
      ],
      ctaText: 'Bereit zu verdienen?', ctaBtn: 'Fahrerkonto erstellen',
    },
    aboutPage: {
      badge: 'Über HayTaxi', title: 'Taxi das einfach funktioniert',
      subtitle: 'HayTaxi ist eine einfache Taxi-Plattform. Keine Preisschwankungen, keine versteckten Gebühren.',
      stats: [
        { value: '€2.00', label: 'Pro km - Festpreis' },
        { value: '< 30s', label: 'Zeit zum Buchen' },
        { value: '100%',  label: 'Tarif geht an Fahrer' },
      ],
      missionTitle: 'Unsere Mission',
      mission1: 'Wir haben HayTaxi gebaut, weil bestehende Plattformen zu kompliziert geworden waren.',
      mission2: 'Unser Ziel: Fahrgäste und Fahrer mit möglichst wenig Reibung verbinden.',
      valuesTitle: 'Wofür wir stehen',
      values: [
        { title: 'Transparente Preise', desc: 'Preis vor Bestätigung angezeigt. Keine Preisschwankungen.' },
        { title: 'Einfach by Design',   desc: 'Fahrt in unter 30 Sekunden buchen.' },
        { title: 'Fair für Fahrer',     desc: 'Fahrer behalten 100% des Tarifs.' },
      ],
      techTitle: 'Mit modernen Technologien gebaut',
      techDesc: 'HayTaxi ist ein MVP-Projekt mit einem vollständigen Produktions-Stack.',
      ctaTitle: 'Bereit es auszuprobieren?', ctaDesc: 'Fahrt buchen oder als Fahrer anmelden.',
      ctaBook: 'Fahrt buchen', ctaDrive: 'Fahrer werden',
    },
    admin: {
      title: 'Admin-Panel', back: '← Zurück',
      tabUsers: 'Benutzer', tabRides: 'Fahrten',
      block: 'Sperren', unblock: 'Entsperren', cancelRide: 'Stornieren',
      blocked: 'Gesperrt', active: 'Aktiv',
      role: 'Rolle', status: 'Status', name: 'Name', username: 'Benutzername',
      noUsers: 'Keine Benutzer', noRides: 'Keine Fahrten',
      confirmBlock: 'Benutzer sperren?', confirmCancel: 'Fahrt stornieren?',
      yes: 'Ja', no: 'Nein',
    },
  },

  ru: {
    nav: { riders: 'Пассажиры', drivers: 'Водители', about: 'О нас', help: 'Помощь', signIn: 'Войти', register: 'Регистрация', signOut: 'Выйти', profile: 'Профиль' },
    notifications: {
      title: 'Уведомления', markAllRead: 'Отметить все как прочитанные', empty: 'Уведомлений пока нет',
      types: {
        NEW_RIDE: 'Доступен новый заказ',
        RIDE_ACCEPTED: 'Водитель в пути!',
        RIDE_ARRIVED: 'Водитель приехал',
        RIDE_STARTED: 'Поездка началась',
        RIDE_COMPLETED: 'Поездка завершена',
        RIDE_CANCELLED: 'Поездка была отменена',
      },
    },
    validation: { required: 'Это поле обязательно для заполнения.', email: 'Введите корректный адрес электронной почты.' },
    footer: {
      copy: '© 2026 HayTaxi. Все права защищены.',
      tagline: 'Быстрые, безопасные и надёжные поездки — когда вам нужно.',
      company: 'Компания', about: 'О нас', help: 'Помощь',
      ridersCol: 'Пассажирам', bookRide: 'Заказать поездку', howItWorks: 'Как это работает',
      driversCol: 'Водителям', becomeDriver: 'Стать водителем',
    },
    landing: {
      badge: 'Быстро · Безопасно · Надёжно',
      h1a: 'Приложение такси,', h1b: 'которое довезёт', h1c: 'вас куда надо.',
      subtitle: 'Закажите поездку за секунды, следите за водителем в реальном времени и добирайтесь безопасно.',
      bookBtn: 'Заказать такси', driveBtn: 'Стать водителем',
      stat1: 'Поездок выполнено', stat2: 'Активных водителей', stat3: 'Средний рейтинг',
      featuresTitle: 'Почему HayTaxi?',
      featuresSubtitle: 'Всё что нужно для комфортной поездки.',
      features: [
        { title: 'Быстрая подача',      desc: 'Водитель приедет за минуты. Мгновенный подбор ближайших водителей.' },
        { title: 'Безопасно и надёжно', desc: 'Все поездки отслеживаются. Прозрачные цены без скрытых платежей.' },
        { title: 'Удобная оплата',      desc: 'Платите картой или наличными. Цена известна до подтверждения.' },
      ],
      howBadge: 'Как это работает',
      howTitle: 'Заказать такси\nза 30 секунд.',
      steps: [
        { title: 'Введите маршрут',        desc: 'Укажите откуда и куда — цена появится сразу.' },
        { title: 'Подтвердите поездку',    desc: 'Ближайший водитель примет заказ за секунды.' },
        { title: 'Наслаждайтесь поездкой', desc: 'Следите за водителем в реальном времени.' },
      ],
      bookNow: 'Заказать — это бесплатно',
      priceLabel: 'Расчёт стоимости', distLabel: 'Расстояние', durLabel: 'Время', priceTag: 'Цена',
      confirmBook: 'Подтвердить заказ',
      driverTitle: 'Работайте с нами.\nЗарабатывайте по своему графику.',
      driverDesc: 'Присоединяйтесь к водителям, которые уже зарабатывают с HayTaxi. Сами выбираете часы, принимаете заказы когда хотите, получаете выплаты еженедельно.',
      startDriving: 'Начать работу', learnMore: 'Подробнее',
      driverPerks: [
        ['💰', 'Еженедельные выплаты', 'Прямо на карту'],
        ['📱', 'Простое приложение',   'Принять заказ одним касанием'],
        ['🗓️', 'Гибкий график',        'Работайте когда удобно'],
        ['⭐', 'Высокий рейтинг',      'Получайте бонусы'],
      ],
    },
    auth: {
      back: '← Назад',
      loginTitle: 'С возвращением',
      registerTitle: 'Создать аккаунт',
      loginSubtitle: 'Войдите чтобы продолжить',
      joinAsRider: 'Зарегистрироваться как пассажир',
      joinAsDriver: 'Зарегистрироваться как водитель',
      namePlaceholder: 'Полное имя',
      usernamePlaceholder: 'Email / имя пользователя',
      emailPlaceholder: 'Email',
      passwordPlaceholder: 'Пароль',
      roleRider: 'Пассажир',
      roleDriver: 'Водитель',
      forgotPassword: 'Забыли пароль?',
      loading: 'Подождите…',
      signIn: 'Войти',
      createAccount: 'Создать аккаунт',
      noAccount: 'Нет аккаунта?',
      hasAccount: 'Уже есть аккаунт?',
      signUp: 'Зарегистрироваться',
      passwordMinLength: 'Пароль должен содержать не менее 6 символов.',
      genericError: 'Что-то пошло не так. Попробуйте снова.',
      checkEmailTitle: 'Проверьте почту',
      checkEmailBefore: 'Мы отправили ссылку для подтверждения на ',
      checkEmailAfter: '. Перейдите по ней, чтобы активировать аккаунт, затем войдите.',
      backToSignIn: 'Назад ко входу',
      resendLink: 'Не пришло письмо? Отправить ещё раз',
      resendSent: 'Письмо с подтверждением отправлено повторно.',
      resendError: 'Не удалось отправить письмо. Попробуйте позже.',
    },
    verifyEmail: {
      title: 'Подтверждение почты',
      verifying: 'Подтверждаем вашу почту…',
      successMsg: 'Почта подтверждена. Теперь вы можете войти.',
      errorMsg: 'Ссылка для подтверждения недействительна или устарела.',
      backToSignIn: 'Назад ко входу',
    },
    forgotModal: {
      title: 'Забыли пароль?',
      subtitle: 'Введите email, и мы отправим вам ссылку для сброса пароля.',
      emailPlaceholder: 'ваш@email.com',
      cancel: 'Отмена',
      send: 'Отправить ссылку',
      sending: 'Отправляем…',
      successBefore: 'Мы отправили ссылку для сброса пароля на ',
      successAfter: '. Перейдите по ней, чтобы задать новый пароль. Ссылка действует 1 час.',
      gotIt: 'Понятно',
      genericError: 'Что-то пошло не так. Попробуйте снова.',
    },
    resetPassword: {
      title: 'Новый пароль',
      subtitle: 'Введите новый пароль для вашего аккаунта.',
      newPassword: 'Новый пароль',
      confirmPassword: 'Повторите новый пароль',
      submitBtn: 'Сохранить пароль',
      updating: 'Сохраняем…',
      successMsg: 'Пароль изменён. Теперь вы можете войти с новым паролем.',
      backToSignIn: 'Назад ко входу',
      errFill: 'Заполните все поля.',
      errMatch: 'Пароли не совпадают.',
      errLength: 'Пароль должен содержать не менее 6 символов.',
      errGeneral: 'Что-то пошло не так. Попробуйте снова.',
    },
    booking: {
      subtitle: 'Заполните данные и подтвердите поездку.',
      signInToBook: 'Войдите чтобы заказать',
      loginHint: 'Перед подтверждением потребуется войти в аккаунт',
      calculating: 'Считаем расстояние…',
      distanceError: 'Не удалось рассчитать расстояние. Введите вручную.',
    },
    client: {
      back: '← Назад', backHome: '← На главную',
      welcome: 'Добро пожаловать,', subtitle: 'Закажите поездку или следите за активными заказами.',
      totalRides: 'Всего поездок', completed: 'Завершено',
      active: 'Активные', completedSection: 'Завершённые', cancelledSection: 'Отменённые',
      noRides: 'Поездок пока нет', noRidesHint: 'Закажите первую поездку',
      bookError: 'Не удалось заказать. Попробуйте снова.',
      cancelError: 'Не удалось отменить поездку. Попробуйте снова.',
      rateError: 'Не удалось отправить оценку. Попробуйте снова.',
      notifyAccepted: 'Водитель едет к вам!', notifyArrived: 'Водитель приехал!', notifyStarted: 'Поездка началась', notifyCompleted: 'Поездка завершена!', notifyCancelled: 'Ваша поездка отменена.',
      newRide: 'Новая поездка', hideForm: 'Скрыть форму', loadMore: 'Загрузить ещё',
    },
    driver: {
      back: '← Назад', online: 'Онлайн', offline: 'Офлайн', onlineError: 'Не удалось обновить статус',
      subtitle: 'Принимайте заказы и следите за заработком.',
      totalRides: 'Всего поездок', earned: 'Заработано', available: 'Доступно сейчас',
      availableTitle: 'Доступные заказы', currentRide: 'Текущая поездка',
      noRides: 'Новых заказов пока нет', noRidesHint: 'Ожидание новых запросов',
      myRides: 'Мои поездки',
      acceptError: 'Не удалось принять заказ - возможно, его уже взяли.',
      completeError: 'Не удалось завершить поездку.',
      cancelError: 'Не удалось отменить поездку. Попробуйте снова.',
      geoError: 'GPS недоступен. Ваше местоположение не будет обновляться.',
      rateClientError: 'Не удалось отправить оценку. Попробуйте снова.',
      notifyNewRide: 'Новый запрос на поездку!',
      loadMore: 'Загрузить ещё',
      offlineMsg: 'Вы офлайн.',
      offlineHint: 'Включите режим онлайн выше, чтобы принимать заказы.',
    },
    rideForm: {
      title: 'Заказать поездку',
      pickup: 'Откуда', dropoff: 'Куда',
      distLabel: 'Расстояние (км)', distHint: '— по умолчанию 5 км', distPlaceholder: 'напр. 8.5',
      perKm: '€2.00/км', confirm: 'Подтвердить', booking: 'Оформляем…',
    },
    rideCard: {
      rideNum: 'Поездка #',
      status: { NEW: 'Ищем водителя', ACCEPTED: 'В пути', ARRIVED: 'Водитель приехал', IN_PROGRESS: 'В поездке', COMPLETED: 'Завершена', CANCELLED: 'Отменена' },
      accept: 'Принять', arrive: 'Я приехал', start: 'Начать поездку', complete: 'Завершить ✓', cancel: 'Отменить',
      cancelConfirmText: 'Вы уверены что хотите отменить поездку?',
      cancelConfirm: 'Да, отменить', cancelDeny: 'Нет, оставить',
      driverPhone: 'Телефон водителя', clientPhone: 'Телефон пассажира',
      eta: 'Водитель приедет через ~{min} мин',
      rateRide: 'Оценить поездку', yourRating: 'Ваша оценка',
      reviewPlaceholder: 'Оставьте отзыв (необязательно)', submitRating: 'Отправить оценку',
      ratePassenger: 'Оцените пассажира', yourRatingOfPassenger: 'Ваша оценка пассажира',
    },
    usersList: {
      riders: 'Пассажиры', drivers: 'Водители',
      registeredRiders: 'пассажиров зарегистрировано', registeredDrivers: 'водителей зарегистрировано',
      bookBtn: 'Заказать такси', driveBtn: 'Стать водителем',
      noRiders: 'Пассажиров пока нет', noDrivers: 'Водителей пока нет',
      loading: 'Загрузка…', back: '← На главную',
    },
    help: {
      title: 'Центр помощи', subtitle: 'Ответы на частые вопросы.',
      back: '← На главную', soon: 'Больше материалов скоро появится…',
      sections: [
        { icon: '🚕', title: 'Как заказать поездку',   desc: 'Нажмите "Регистрация", введите данные, укажите маршрут и подтвердите заказ.' },
        { icon: '🚗', title: 'Как стать водителем',    desc: 'Нажмите "Войти", выберите роль Водитель и начните принимать заказы.' },
        { icon: '💳', title: 'Оплата',                 desc: 'Принимаем карту и наличные. Цена рассчитывается заранее до подтверждения.' },
        { icon: '📞', title: 'Связаться с поддержкой', desc: 'Возникли проблемы? Напишите нам и мы ответим как можно скорее.' },
      ],
    },
    greeting: { morning: 'Доброе утро', afternoon: 'Добрый день', evening: 'Добрый вечер' },
    profile: {
      back: '← Назад', title: 'Профиль',
      accountSection: 'Аккаунт', name: 'Имя', email: 'Email', role: 'Роль', phone: 'Телефон', phonePlaceholder: '+71234567890', phoneBtn: 'Сохранить', phoneSaved: 'Номер сохранён', phoneError: 'Не удалось сохранить номер. Попробуйте снова.',
      passwordSection: 'Сменить пароль',
      oldPassword: 'Старый пароль', newPassword: 'Новый пароль', confirmPassword: 'Повторите новый пароль',
      updateBtn: 'Обновить пароль', updating: 'Обновляем…',
      successMsg: 'Ваш пароль успешно изменён, подтверждение отправлено на вашу почту. Если это были не вы — обратитесь в техподдержку.',
      errFill: 'Заполните все поля.',
      errMatch: 'Новые пароли не совпадают.',
      errLength: 'Новый пароль должен содержать не менее 6 символов.',
      errGeneral: 'Что-то пошло не так. Попробуйте снова.',
      confirmTitle: 'Сменить пароль?',
      confirmText: 'Вы уверены что хотите изменить пароль аккаунта?',
      confirmYes: 'Да', confirmNo: 'Нет',
    },
    ridersPage: {
      badge: 'Для пассажиров', title: 'Такси за несколько секунд',
      subtitle: 'Введите маршрут, увидите цену, водитель уже едет. Без скрытых платежей.',
      bookBtn: 'Заказать сейчас', pricingTitle: 'Простые тарифы',
      pricingDesc: 'Цена показана до подтверждения. Вы видите то, что платите.',
      howTitle: 'Как это работает',
      steps: [
        { title: 'Введите маршрут',        desc: 'Укажите откуда и куда. Цена появится сразу.' },
        { title: 'Подтвердите поездку',    desc: 'Проверьте цену и расстояние, нажмите Подтвердить.' },
        { title: 'Водитель едет',          desc: 'Ближайший водитель примет заказ за секунды.' },
        { title: 'Прибудьте безопасно',    desc: 'Достигните цели. Оплата рассчитается автоматически.' },
      ],
      faqTitle: 'Частые вопросы',
      faqs: [
        { q: 'Нужен ли аккаунт для заказа?',        a: 'Нет - маршрут и цену можно видеть без входа. Аккаунт нужен только для подтверждения.' },
        { q: 'Как рассчитывается цена?',             a: 'Цена = расстояние в км x €2.00. Расстояние рассчитывается автоматически.' },
        { q: 'Можно ли отменить поездку?',           a: 'Да - любую незавершённую поездку можно отменить. Нажмите Отменить на карточке.' },
        { q: 'Что если нет доступных водителей?',   a: 'Заказ остаётся в очереди. Водители видят все открытые заказы.' },
      ],
      ctaText: 'Готовы ехать?', ctaBtn: 'Заказать первую поездку',
    },
    driversPage: {
      badge: 'Для водителей', title: 'Работайте на своих условиях',
      subtitle: 'Сами выбираете часы, принимаете заказы когда хотите, получаете выплаты еженедельно.',
      driveBtn: 'Начать работу',
      perks: [
        { title: 'Гибкий график',        desc: 'Работайте когда хотите. Без минимальных часов.' },
        { title: 'Еженедельные выплаты', desc: 'Заработок рассчитывается автоматически и выплачивается еженедельно.' },
        { title: 'Простое приложение',   desc: 'Принять заказ одним касанием. Никаких сложных настроек.' },
        { title: 'Прозрачный заработок', desc: 'Видите сколько заработаете до принятия заказа.' },
      ],
      earningsTitle: 'Пример заработка',
      earningsDesc: 'Поездка 10 км приносит €20.00. 5 поездок в день = €100+.',
      howTitle: 'Как начать',
      steps: [
        { title: 'Создайте аккаунт водителя', desc: 'Зарегистрируйтесь и выберите роль Водитель. Меньше минуты.' },
        { title: 'Выйдите онлайн',            desc: 'Откройте дашборд. Сразу видны пассажирам.' },
        { title: 'Принимайте заказы',         desc: 'Новые заказы появляются в реальном времени.' },
        { title: 'Завершайте и зарабатывайте', desc: 'Отметьте поездку завершённой - заработок обновится мгновенно.' },
      ],
      faqTitle: 'Частые вопросы',
      faqs: [
        { q: 'Нужны особые права?',               a: 'Нужны действующие водительские права. Требования зависят от страны.' },
        { q: 'Сколько можно заработать?',          a: 'Каждая поездка приносит €2.00 за км.' },
        { q: 'Можно выбирать какие заказы брать?', a: 'Да - видите откуда и куда до принятия.' },
        { q: 'Что если пассажир отменит?',         a: 'Никаких штрафов. Просто возвращаетесь в пул доступных.' },
      ],
      ctaText: 'Готовы зарабатывать?', ctaBtn: 'Создать аккаунт водителя',
    },
    aboutPage: {
      badge: 'О HayTaxi', title: 'Такси которое просто работает',
      subtitle: 'HayTaxi - простая платформа такси без лишних сложностей. Никаких скрытых платежей, никаких сюрпризов.',
      stats: [
        { value: '€2.00', label: 'За км - фиксированная цена' },
        { value: '< 30с', label: 'Время заказа поездки' },
        { value: '100%',  label: 'Тариф достаётся водителю' },
      ],
      missionTitle: 'Наша миссия',
      mission1: 'Мы создали HayTaxi потому что существующие платформы стали слишком сложными.',
      mission2: 'Наша цель проста: соединять пассажиров и водителей с минимальными трудностями.',
      valuesTitle: 'Наши ценности',
      values: [
        { title: 'Прозрачные цены',   desc: 'Цена показана до подтверждения. Без скачков цен, без скрытых платежей.' },
        { title: 'Простота в дизайне', desc: 'Заказ поездки за 30 секунд. Без лишних шагов.' },
        { title: 'Честно для водителей', desc: 'Водители получают 100% тарифа. Без комиссий.' },
      ],
      techTitle: 'Создано на современных технологиях',
      techDesc: 'HayTaxi - MVP проект на полноценном продакшн стеке.',
      ctaTitle: 'Готовы попробовать?', ctaDesc: 'Закажите поездку или зарегистрируйтесь как водитель.',
      ctaBook: 'Заказать поездку', ctaDrive: 'Стать водителем',
    },
    admin: {
      title: 'Панель администратора', back: '← Назад',
      tabUsers: 'Пользователи', tabRides: 'Поездки',
      block: 'Заблокировать', unblock: 'Разблокировать', cancelRide: 'Отменить',
      blocked: 'Заблокирован', active: 'Активен',
      role: 'Роль', status: 'Статус', name: 'Имя', username: 'Логин',
      noUsers: 'Пользователи не найдены', noRides: 'Поездки не найдены',
      confirmBlock: 'Заблокировать пользователя?', confirmCancel: 'Отменить поездку?',
      yes: 'Да', no: 'Нет',
    },
  },

  hy: {
    nav: { riders: 'Ուղևորներ', drivers: 'Վարորդներ', about: 'Մեր մասին', help: 'Օգնություն', signIn: 'Մուտք', register: 'Գրանցվել', signOut: 'Ելք', profile: 'Պրոֆիլ' },
    notifications: {
      title: 'Ծանուցումներ', markAllRead: 'Նշել բոլորը որպես կարդացված', empty: 'Առայժմ ծանուցումներ չկան',
      types: {
        NEW_RIDE: 'Հասանելի է նոր պատվեր',
        RIDE_ACCEPTED: 'Վարորդը ճանապարհին է!',
        RIDE_ARRIVED: 'Վարորդը ժամանել է',
        RIDE_STARTED: 'Ձեր ուղևորությունը սկսվեց',
        RIDE_COMPLETED: 'Ուղևորությունն ավարտված է',
        RIDE_CANCELLED: 'Ուղևորությունը չեղարկվեց',
      },
    },
    validation: { required: 'Այս դաշտը պարտադիր է:', email: 'Մուտքագրեք վավեր էլ. փոստի հասցե:' },
    footer: {
      copy: '© 2026 HayTaxi. Բոլոր իրավունքները պաշտպանված են։',
      tagline: 'Արագ, անվտанг և հուսAlי ճanаparhordutjunner։',
      company: 'Ընկերություն', about: 'Մեր մասին', help: 'Օգնություն',
      ridersCol: 'Ուղևորների', bookRide: 'Պատվիրել տակսի', howItWorks: 'Ինճպես ե աշխատում',
      driversCol: 'Վարորդների', becomeDriver: 'Դարնալ վարոդ',
    },
    landing: {
      badge: 'Արագ · Անվտանգ · Հուսալի',
      h1a: 'Տաքսի հավելված,', h1b: 'որը կտանի', h1c: 'ձեզ ուր ուզում եք։',
      subtitle: 'Պատվիրեք ուղևորություն վայրկյանների ընթացքում, հետևեք վարորդին իրական ժամանակում։',
      bookBtn: 'Պատվիրել տաքսի', driveBtn: 'Դառնալ վարորդ',
      stat1: 'Ավարտված ուղևորություններ', stat2: 'Ակտիվ վարորդներ', stat3: 'Միջին վարկանիշ',
      featuresTitle: 'Ինչու HayTaxi?',
      featuresSubtitle: 'Ամեն ինչ հարմարավետ ճանապարհորդության համար։',
      features: [
        { title: 'Արագ ժամանում',       desc: 'Վարորդը կժամանի րոպեների ընթացքում։' },
        { title: 'Անվտանգ և հուսալի',   desc: 'Բոլոր ուղևորությունները հետևվում են։ Թափանցիկ գներ։' },
        { title: 'Հեշտ վճարում',        desc: 'Վճարեք քարտով կամ կանխիկ։ Գինը հայտնի է հաստատելուց առաջ։' },
      ],
      howBadge: 'Ինչպես է աշխատում',
      howTitle: 'Տաքսի պատվիրեք\n30 վայրկյանում։',
      steps: [
        { title: 'Մուտքագրեք երթուղին',   desc: 'Նշեք ուստի և ուր - գինն անմիջապես կհայտնվի։' },
        { title: 'Հաստատեք ուղևորությունը', desc: 'Մոտակա վարորդը կընդունի պատվերը վայրկյանների ընթացքում։' },
        { title: 'Վայելեք ճանապարհը',     desc: 'Հետևեք վարորդին իրական ժամանակում։' },
      ],
      bookNow: 'Պատվիրել հիմա',
      priceLabel: 'Գնի հաշվարկ', distLabel: 'Հեռավորություն', durLabel: 'Ժամանակ', priceTag: 'Գին',
      confirmBook: 'Հաստատել պատվերը',
      driverTitle: 'Աշխատեք մեզ հետ։\nՎաստակեք ձեր ժամանակացույցով։',
      driverDesc: 'Միացեք HayTaxi-ի հետ արդեն վաստակող վարորդներին։ Ինքներդ ընտրեք ժամերը, ընդունեք պատվերներ երբ ուզում եք։',
      startDriving: 'Սկսել աշխատել', learnMore: 'Իմանալ ավելին',
      driverPerks: [
        ['💰', 'Շաբաթական վճարումներ', 'Ուղղակի ձեր քարտին'],
        ['📱', 'Պարզ հավելված',        'Ընդունեք մեկ հպումով'],
        ['🗓️', 'Ճկուն գրաֆիկ',         'Աշխատեք երբ հարմար է'],
        ['⭐', 'Բարձր վարկանիշ',       'Վաստակեք բոնուսներ'],
      ],
    },
    auth: {
      back: '← Հետ',
      loginTitle: 'Բարի վերադարձ',
      registerTitle: 'Ստեղծել հաշիվ',
      loginSubtitle: 'Մուտք գործեք շարունակելու համար',
      joinAsRider: 'Միանալ որպես ուղևոր',
      joinAsDriver: 'Միանալ որպես վարորդ',
      namePlaceholder: 'Անուն ազգանուն',
      usernamePlaceholder: 'Էլ. հասցե / օգտանուն',
      emailPlaceholder: 'Էլ. հասցե',
      passwordPlaceholder: 'Գաղտնաբառ',
      roleRider: 'Ուղևոր',
      roleDriver: 'Վարորդ',
      forgotPassword: 'Մոռացե՞լ եք գաղտնաբառը',
      loading: 'Խնդրում ենք սպասել…',
      signIn: 'Մուտք',
      createAccount: 'Ստեղծել հաշիվ',
      noAccount: 'Հաշիվ չունե՞ք',
      hasAccount: 'Արդեն ունեք հաշիվ?',
      signUp: 'Գրանցվել',
      passwordMinLength: 'Գաղտնաբառը պետք է լինի առնվազն 6 նիշ։',
      genericError: 'Ինչ-որ բան սխալ գնաց։ Փորձեք կրկին։',
      checkEmailTitle: 'Ստուգեք ձեր էլ. փոստը',
      checkEmailBefore: 'Մենք ուղարկել ենք հաստատման հղում հետևյալ հասցեին՝ ',
      checkEmailAfter: '։ Բացեք այն հաշիվը ակտիվացնելու համար, ապա մուտք գործեք։',
      backToSignIn: 'Վերադառնալ մուտքին',
      resendLink: 'Նամակը չստացվեց? Կրկին ուղարկել',
      resendSent: 'Հաստատման նամակը կրկին ուղարկվեց։',
      resendError: 'Չհաջողվեց կրկին ուղարկել նամակը։ Փորձեք ավելի ուշ։',
    },
    verifyEmail: {
      title: 'Հաստատեք ձեր էլ. փոստը',
      verifying: 'Հաստատում ենք ձեր էլ. փոստը…',
      successMsg: 'Ձեր էլ. փոստը հաստատվեց։ Այժմ կարող եք մուտք գործել։',
      errorMsg: 'Հաստատման հղումը անվավեր է կամ ժամկետանց է։',
      backToSignIn: 'Վերադառնալ մուտքին',
    },
    forgotModal: {
      title: 'Մոռացե՞լ եք գաղտնաբառը',
      subtitle: 'Մուտքագրեք ձեր էլ. հասցեն, և մենք կուղարկենք գաղտնաբառի վերականգնման հղում։',
      emailPlaceholder: 'ձեր@email.com',
      cancel: 'Չեղարկել',
      send: 'Ուղարկել հղումը',
      sending: 'Ուղարկվում է…',
      successBefore: 'Մենք ուղարկեցինք գաղտնաբառի վերականգնման հղում ',
      successAfter: ' հասցեին։ Բացեք այն՝ նոր գաղտնաբառ սահմանելու համար։ Հղումը գործում է 1 ժամ։',
      gotIt: 'Հասկացա',
      genericError: 'Ինչ-որ բան սխալ գնաց։ Փորձեք կրկին։',
    },
    resetPassword: {
      title: 'Սահմանել նոր գաղտնաբառ',
      subtitle: 'Մուտքագրեք նոր գաղտնաբառ ձեր հաշվի համար։',
      newPassword: 'Նոր գաղտնաբառ',
      confirmPassword: 'Կրկնել նոր գաղտնաբառը',
      submitBtn: 'Սահմանել գաղտնաբառը',
      updating: 'Թարմացվում է…',
      successMsg: 'Ձեր գաղտնաբառը փոխվել է։ Այժմ կարող եք մուտք գործել նրանով։',
      backToSignIn: 'Վերադառնալ մուտք գործելուն',
      errFill: 'Լրացրեք բոլոր դաշտերը։',
      errMatch: 'Գաղտնաբառերը չեն համընկնում։',
      errLength: 'Գաղտնաբառը պետք է ունենա առնվազն 6 նիշ։',
      errGeneral: 'Ինչ-որ բան սխալ գնաց։ Փորձեք կրկին։',
    },
    booking: {
      subtitle: 'Լրացրեք տվյալները և հաստատեք ուղևորությունը։',
      signInToBook: 'Մուտք գործեք պատվիրելու համար',
      loginHint: 'Հաստատելուց առաջ անհրաժեշտ է մուտք գործել',
      calculating: 'Հաշվարկում ենք հեռավորությունը…',
      distanceError: 'Հնարավոր չէ հաշվարկել հեռավորությունը։ Մուտքագրեք ձեռքով։',
    },
    client: {
      back: '← Հետ', backHome: '← Գլխավոր',
      welcome: 'Բարի գալուստ,', subtitle: 'Պատվիրեք ուղևորություն կամ հետևեք ակտիվ պատվերներին։',
      totalRides: 'Ընդամենը ուղևորություն', completed: 'Ավարտված',
      active: 'Ակտիվ', completedSection: 'Ավարտված', cancelledSection: 'Չեղարկված',
      noRides: 'Ուղևորություններ դեռ չկան', noRidesHint: 'Պատվիրեք առաջին ուղևորությունը',
      bookError: 'Չհաջողվեց պատվիրել։ Փորձեք կրկին։',
      cancelError: 'Չհաջողվեց չեղարկել։ Փորձեք կրկին։',
      rateError: 'Չհաջողվեց ուղարկել գնահատականը։ Փորձեք կրկին։',
      notifyAccepted: 'Վարորդը ճանապարհին է!', notifyArrived: 'Ձեր վարորդը ժամանել է!', notifyStarted: 'Ձեր ուղևորությունը սկսվեց', notifyCompleted: 'Ուղևորությունն ավարտված է!', notifyCancelled: 'Ձեր ուղևորությունը չեղարկվել է։',
      newRide: 'Նոր ուղևորություն', hideForm: 'Թաքցնել ձևը', loadMore: 'Ավելին',
    },
    driver: {
      back: '← Հետ', online: 'Առցանց', offline: 'Անցանց', onlineError: 'Հնարավոր չէ թարմացնել կարգավիճակը',
      subtitle: 'Ընդունեք պատվերներ և հետևեք ձեր վաստակին։',
      totalRides: 'Ընդամենը ուղևորություն', earned: 'Վաստակված', available: 'Հասանելի հիմա',
      availableTitle: 'Հասանելի պատվերներ', currentRide: 'Ընթացիկ ուղևորություն',
      noRides: 'Նոր պատվերներ չկան', noRidesHint: 'Սպասում է նոր հայտերի',
      myRides: 'Իմ ուղևորությունները',
      acceptError: 'Չհաջողվեց ընդունել - հնարավոր է արդեն ընդունված է։',
      completeError: 'Չհաջողվեց ավարտել ուղևորությունը։',
      cancelError: 'Չհաջողվեց չեղարկել ուղևորությունը։ Փորձեք կրկին։',
      geoError: 'GPS անհասանելի է։ Ձեր գտնվելու վայրը չի թարմացվի։',
      rateClientError: 'Չհաջողվեց ուղարկել գնահատականը։ Փորձեք կրկին։',
      notifyNewRide: 'Նոր ուղևորության հայտ!',
      loadMore: 'Ավելին',
      offlineMsg: 'Դուք անցանց եք։',
      offlineHint: 'Վերևում միացրեք առցանց ռեժիմը ուղևորություններ ընդունելու համար։',
    },
    rideForm: {
      title: 'Պատվիրել ուղևորություն',
      pickup: 'Ուստի', dropoff: 'Ուր',
      distLabel: 'Հեռավորություն (կմ)', distHint: '— կանխադրված 5 կմ', distPlaceholder: 'օր. 8.5',
      perKm: '€2.00/կմ', confirm: 'Հաստատել', booking: 'Ձևակերպում…',
    },
    rideCard: {
      rideNum: 'Ուղևորություն #',
      status: { NEW: 'Փնտրում ենք վարորդ', ACCEPTED: 'Ճանապարհին է', ARRIVED: 'Վարորդը ժամանել է', IN_PROGRESS: 'Ընթացքի մեջ է', COMPLETED: 'Ավարտված', CANCELLED: 'Չեղարկված' },
      accept: 'Ընդունել', arrive: 'Ես ժամանեցի', start: 'Սկսել ուղևորությունը', complete: 'Ավարտել ✓', cancel: 'Չեղаркел',
      cancelConfirmText: 'Վатне՞ kchelarkel ayd utevorutyunne?',
      cancelConfirm: 'Ayo, chelarkel', cancelDeny: 'Oc, pahel',
      driverPhone: 'Վարորդի հեռ.', clientPhone: 'Ուղևորի հեռ.',
      eta: 'Վааrordi ~{min} ропе кжамани',
      rateRide: 'Գնահատել', yourRating: 'Ձեր գնահատականը',
      reviewPlaceholder: 'Թողեք կարծիք (ոչ պարտադիր)', submitRating: 'Ուղարկել գնահատականը',
      ratePassenger: 'Գնահատեք ուղևորին', yourRatingOfPassenger: 'Ձեր գնահատականը ուղևորի համար',
    },
    usersList: {
      riders: 'Ուղևորներ', drivers: 'Վարորդներ',
      registeredRiders: 'ուղևոր գրանցված', registeredDrivers: 'վարորդ գրանցված',
      bookBtn: 'Պատվիրել տաքսի', driveBtn: 'Դառնալ վարորդ',
      noRiders: 'Ուղևորներ դեռ չկան', noDrivers: 'Վարորդներ դեռ չկան',
      loading: 'Բեռնում…', back: '← Գլխավոր',
    },
    help: {
      title: 'Օգնության կենտրոն', subtitle: 'Պատասխաններ հաճախ տրվող հարցերին։',
      back: '← Գլխավոր', soon: 'Շուտով ավելի շատ բովանդակություն…',
      sections: [
        { icon: '🚕', title: 'Ինչպես պատվիրել ուղևորություն', desc: 'Սեղմեք "Գրանցվել", մուտքագրեք տվյալները, նշեք երթուղին և հաստատեք պատվերը։' },
        { icon: '🚗', title: 'Ինչպես դառնալ վարորդ',          desc: 'Սեղմեք "Մուտք", ընտրեք Վարորդ դերը և սկսեք ընդունել պատվերներ։' },
        { icon: '💳', title: 'Վճարում',                        desc: 'Ընդունում ենք քարտ և կանխիկ։ Գինը հայտնի է հաստատելուց առաջ։' },
        { icon: '📞', title: 'Կապ աջակցության հետ',           desc: 'Խնդիր ունե՞ք։ Գրեք մեզ և մենք կպատասխանենք հնարավորինս շուտ։' },
      ],
    },
    greeting: { morning: 'Բարի լույс', afternoon: 'Բարի օր', evening: 'Բարի երեկո' },

    profile: {
      back: '← Հետ', title: 'Պրոֆիլ',
      accountSection: 'Հաշիվ', name: 'Անուն', email: 'Էլ. հասցե', role: 'Դեր', phone: 'Հեռախոս', phonePlaceholder: '+37491234567', phoneBtn: 'Պահպանել', phoneSaved: 'Համարը պահպանված է', phoneError: 'Չհաջողվեց պահպանել համարը։ Փորձեք կրկին։',
      passwordSection: 'Փոխել գաղտնաբառը',
      oldPassword: 'Հին գաղտնաբառ', newPassword: 'Նոր գաղտնաբառ', confirmPassword: 'Կրկնել նոր գաղտնաբառը',
      updateBtn: 'Թարմացնել գաղտնաբառը', updating: 'Թարմացվում է…',
      successMsg: 'Ձեր գաղտնաբառը հաջողությամբ փոխվել է, հաստատագիրն ուղարկվել է Ձեր փոստին։ Եթե դա Դուք չեք, կապվեք աջակցության հետ։',
      errFill: 'Լրացրեք բոլոր դաշտերը։',
      errMatch: 'Նոր գաղտնաբառները չեն համընկնում։',
      errLength: 'Նոր գաղտնաբառը պետք է ունենա առնվազն 6 նիշ։',
      errGeneral: 'Սխալ է տեղի ունեցել։ Կրկին փորձեք։',
      confirmTitle: 'Փոխե՞լ գաղտնաբառը',
      confirmText: 'Հաստատո՞ւմ եք, որ ուզում եք փոխել Ձեր հաշվի գաղտնաբառը։',
      confirmYes: 'Այո', confirmNo: 'Ոչ',
    },
    ridersPage: {
      badge: 'Ուղևորների համար', title: 'Ուղևորություն վայրկյանների ընթացքում',
      subtitle: 'Մուտքագրեք երթուղին, տեսեք գինը, վարորդն արդեն ճանապարհին է։',
      bookBtn: 'Պատվիրել հիմա', pricingTitle: 'Պարզ սակագներ',
      pricingDesc: 'Գինը ցուցադրվում է հաստատելուց առաջ։ Ինչ տեսնում եք՝ այն էլ վճարում եք։',
      howTitle: 'Ինչպես է աշխատում',
      steps: [
        { title: 'Մուտքագրեք ուղղությունը', desc: 'Նշեք ուստի և ուր։ Գինն անմիջապես կցուցադրվի։' },
        { title: 'Հաստատեք ուղևորությունը', desc: 'Ստուգեք գինն ու հեռavորությունը և հաստատեք։' },
        { title: 'Վարορδը կժամանի',         desc: 'Մոտակա վαρορδ կunդունի պատvereը վayrkyannerի unctumnum.' },
        { title: 'Հասեք անվետանգ',          desc: 'Հասեկ նպատակն անբարտակին։ Վարչումնանավտոմատ կասխվարկվի.' },
      ],
      faqTitle: 'Հաճախ տրվոգ հարծԾե',
      faqs: [
        { q: 'Պետկե հեսապ ունենալ պատատվիրելու համար?', a: 'Վոչ - տեսեկ գինն արանծ մուտկ կատար կրկել. Մուտկ պետկ ե միաին հաստատելուծ արրայտժ.' },
        { q: 'Ինծպես ե գինն հաշվարկվոում?',           a: 'Գին = հերավոտյուն կմ խ €2.00. Հերավոտյունն աուտո կ-հաշվարկվի.' },
        { q: 'Կարոխ եմ կնել ուտեվորուտյուննե?',          a: 'Այո - կարելի ե կնել ծանկածված ավարտի ուտեվորուտյունն.' },
        { q: 'Ինչ անի վարոդում չա?',                 a: 'Ձեզ պատավերկն մնումա շարկին. Վարորոդներե տեսում են բոլոր նահանգժալի պատավերկների.' },
      ],
      ctaText: 'Պատաստրավձհեկ գնալ?', ctaBtn: 'Պատվիրել արաչին ուտեվորուտյուննե'
    },
    driversPage: {
      badge: 'Վարորդների համար', title: 'Աշխատեկ Ձեզ պայմաններով',
      subtitle: 'Ինկեզ կնդիրններ որենծի, անտունեկ պատավերկներ երբ ոունենակ, եվ շարհադժի վարժվոում ես ամենակորրեկն.',
      driveBtn: 'Սկսել աշխատել',
      perks: [
        { title: 'Ճկուշ գրափիկ',          desc: 'Աշխատեկ երբ ոունենակ. Նվազագուին ժամներ չկան.' },
        { title: 'Շաբատական վարժոումներ',  desc: 'Վարաստակին ավտոմած ե հաշվարկվոում եվ վարժոում ե ամեն շաբատ.' },
        { title: 'Պարշտ հավելված',       desc: 'Անտունեկ պատավերկ մեկ հարվալուտժամբ. Բարդակուծ ստվածուտյուն չկա.' },
        { title: 'Տեսանելի վարաստակ',      desc: 'Տեսնոում եկ հենծնես ինչ կվաստեկնախերեվ անտունելոուիծ.' },
      ],
      earningsTitle: 'Վարաստակի որինակ',
      earningsDesc: '10 կմ ուտեվորուտյուննե բերնում ե €20.00. 5 ուտեվորուտյուն որական = €100+.',
      howTitle: 'Ինծպես սկսել',
      steps: [
        { title: 'Ստվարել վարորդի հեսապ',    desc: 'Գրանծվել եվ ենտրել Վարոդ դերե. Կի ներուտ մուտկ եկ րպարկ.' },
        { title: 'Անտրնել ոնլայն',           desc: 'Բածել դաշբորդն. Անմիդժապես տեսանելի ե ուտեվոորներին.' },
        { title: 'Անտունել պատավերկներ',      desc: 'Նոր պատավերկներե տեսանոում են իրաոինդ ժամգին.' },
        { title: 'Ավարտել եվ վարաստակել',    desc: 'Ավարտել ուտեվորուտյուննե եվ վարաստակն անմիդժապես կանալի.' },
      ],
      faqTitle: 'Հատչախ տրվոգ հարծերե',
      faqs: [
        { q: 'Պետկե հատուկ իրավունկ?',           a: 'Պետկե գործնա իրավունկ. Պահանդժներե տարբերում են երկրներով.' },
        { q: 'Ինչ կարոխ եմ վարաստակել?',       a: 'Ամեն ուտեվորուտյուն վարիչում ե €2.00 km-ik.' },
        { q: 'Կարոխ եմ անտրել պատավերկներ?',    a: 'Այո - տեսնոում եկ ուսկեզյ եվ ուրա հերեվ անտունելոուիծ.' },
        { q: 'Ինչ անում ե ուտեվորն կնել?',       a: 'Տուգարմուտժուն չկա. Պետկ ե պրոստո վերնալ աչին պուլոում.' },
      ],
      ctaText: 'Պատաստրավձհեկ վարաստակել?', ctaBtn: 'Ստվարել վարորդի հեսապ',
    },
    aboutPage: {
      badge: 'HayTaxi-ի մասին', title: 'Տակսի վոր ապեստ աշխատում ե',
      subtitle: 'HayTaxi-ն պարշտ տակսի պլատփորմա ե արանս ավելոր բարդուտժունների. Արանս պունկտ կանչին, արանս ծկնուլ տասալներ.',
      stats: [
        { value: '€2.00', label: 'km-ik - հաստատակծկան տարիփ' },
        { value: '< 30ʹ', label: 'Պատվեր անել ժամանակիծ' },
        { value: '100%',  label: 'Տարիփն գնում ե վարորդին' },
      ],
      missionTitle: 'Մենկ մեծ նպատակն',
      mission1: 'HayTaxi-ի համար մենկ ստվելենկ պլատփորմա արանս ավելոր բարդուտժունների.',
      mission2: 'Մենկ նպատակն ունենկ պարգկել ուտեվորներին եվ վարորդներին. Պետկ ե կանակ եվ արդարակեծ.',
      valuesTitle: 'Մենկ արժակներկ',
      values: [
        { title: 'Տեսանելի գիներ',         desc: 'Գինն երեդում ե հաստատելոուծ արրայտժ. Արանս տարիփնի ափխոումներ.' },
        { title: 'Պարշտ դիզայնոում',       desc: 'Զակազ անել արանս 30 վայրկյանում. Արանս ավելոր կադամ.' },
        { title: 'Արդար վարորդերի համար',  desc: 'Վարորդներե պահում են տարիփի 100%. Արանս կոմիսսիոնս.' },
      ],
      techTitle: 'Ստվել արդի տեխնոլոգիաներով',
      techDesc: 'HayTaxi-ն ՄՎՊ նախագիծ ե ստվել լրիվ արտադրանծուտյանյ ստածկ-ով.',
      ctaTitle: 'Պահաստրավձհեկ?', ctaDesc: 'Պատվիրել ուտեվորուտյուն կամ գրանծվել վորպես վարոդ.',
      ctaBook: 'Պատվիրել ուտեվորուտյուն', ctaDrive: 'Դարնալ վարոդ',
    },
    admin: {
      title: 'Admin Panel', back: '← Վերադարձ',
      tabUsers: 'Ոգտահողներներ', tabRides: 'Ուղևորություններ',
      block: 'Արդակել', unblock: 'Բածահանել', cancelRide: 'Բեկելածել',
      blocked: 'Արդակվալ', active: 'Ակտիվ',
      role: 'Դեր', status: 'Կարգավիչակ', name: 'Անուն', username: 'Մուտկ',
      noUsers: 'Ոգտահողներներ չկան', noRides: 'Ուղևորություններ չկան',
      confirmBlock: 'Արդակե՞լ այս ոգտահողնինն', confirmCancel: 'Բեկելածե՞լ այս Ուղևորությունը',
      yes: 'Այո', no: 'Վոչ',
    },
  },
};

export default translations;
